import { useEffect } from 'react';
import { toast } from 'sonner';

export function useStorageMonitor() {
  useEffect(() => {
    const handleStorageQuotaExceeded = () => {
      toast.error(
        "Storage limit reached! Photos from activities have been removed to free up space.", 
        {
          duration: 10000,
          action: {
            label: "Clear All Photos",
            onClick: () => {
              if (confirm("This will remove all photos from your activities. Continue?")) {
                // Clear photos from localStorage
                const savedState = localStorage.getItem('activityTrackerState');
                if (savedState) {
                  try {
                    const state = JSON.parse(savedState);
                    const stateWithoutPhotos = {
                      ...state,
                      activities: state.activities?.map((activity: any) => ({
                        ...activity,
                        photoUrl: undefined
                      })) || []
                    };
                    localStorage.setItem('activityTrackerState', JSON.stringify(stateWithoutPhotos));
                    window.location.reload(); // Reload to apply changes
                  } catch (error) {
                    console.error('Error clearing photos:', error);
                  }
                }
              }
            }
          }
        }
      );
    };

    window.addEventListener('storage-quota-exceeded', handleStorageQuotaExceeded);
    
    return () => {
      window.removeEventListener('storage-quota-exceeded', handleStorageQuotaExceeded);
    };
  }, []);
}